import { render, staticRenderFns } from "./nav-bar-notifications-dropdown.vue?vue&type=template&id=17ee8f91&"
import script from "./nav-bar-notifications-dropdown.vue?vue&type=script&lang=ts&"
export * from "./nav-bar-notifications-dropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports